import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonFeaturesLayout } from "../cta-button-features-layout";
import { CTAButtonFeaturesSimpleListLayoutEnergyContext } from "./features-simple-list-layout-energy.model";

@Component({
    selector: "dodo-features-simple-list-layout-energy",
    templateUrl: "./features-simple-list-layout-energy.component.html",
    styleUrls: ["./features-simple-list-layout-energy.component.scss"],
    standalone: false
})
export class FeaturesSimpleListLayoutEnergyComponent
	extends CTAButtonFeaturesLayout<CTAButtonFeaturesSimpleListLayoutEnergyContext>
	implements OnInit {
	@Input() showInfoIcon: boolean;
	@Input() title: string;
	@Input() features: string[];
	@Input() footnote: string[];

	set context(ctx: CTAButtonFeaturesSimpleListLayoutEnergyContext) {
		this.title = this.title || ctx.title;
		this.features = this.features || ctx.features;
		this.footnote = this.footnote || ctx.footnote;
		this.showInfoIcon = this.showInfoIcon || ctx.showInfoIcon;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
